import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AchievementFacade } from '../facade/achievement.facade';

export function achievementCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const achievementFacade = inject(AchievementFacade);
        achievementFacade.clear();

        return true;
    };
}
